module.exports = __webpack_public_path__ + "static/media/music.d18384e1.mp3";